// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__28GnK","header":"PatientQuestionnaire_header__1pL_6","info":"PatientQuestionnaire_info__1lOFx"};